<div
  tabindex="0"
  class="management-card-container display-flex flex-column grid-gap-10"
  (keydown.enter)="openSubmenu()"
  (click)="openSubmenu()"
>
  <app-icon
    *ngIf="sectionItem?.icon"
    [svg]="sectionItem?.icon"
    [iconColor]="EColorPalette.cGreen3"
    [iconWidth]="32"
    [iconHeight]="32"
  ></app-icon>
  <div class="subtitle">{{ sectionItem?.label }}</div>
</div>
